export default __webpack_public_path__ + "static/media/tvshow2.5e7365a1.jpg";